import axios from "axios";
import { config } from "./Config";
import { toast } from 'react-toastify';
import { stringify } from "querystring";

export const ResponseManagement = (response, callbackSuccess, callbackError) => {
  if(response !== null) {
    if(response.status === 200) {
      if(response.data !== null) {
        if(response.data.success === true || response.data.success === 'true') {
          if (typeof callbackSuccess === 'function') {
            callbackSuccess();
          }
        } else {
          if (typeof callbackError === 'function') {
            callbackError();
          }
        }
      } else {
        let code = 204;
        toast.error(ListErrorHtml[code].description + ", " + ListErrorHtml[code].comment);
        if (typeof callbackError === 'function') {
          callbackError();
        }
      }
    } else {
      toast.error(ListErrorHtml[response.status].description + ", " + ListErrorHtml[response.status].comment);
      if(response.status === 401) {
        toast.error(ListErrorHtml[response.response.status].description + ", " + response.response.data.message);
        let paramUrl = document.location.href.split(config.url.URL)[1].split('/');
        document.location.href = `${config.url.URL}${paramUrl[0]}/${paramUrl[1]}/login`;
      } else {
        if (typeof callbackError === 'function') {
          callbackError();
        }
      }
    }
  } else {
    let code = 500;
    toast.error(ListErrorHtml[code].description + ", " + ListErrorHtml[code].comment);
    if (typeof callbackError === 'function') {
      callbackError();
    }
  }
}

export const ErrorManagement = (error, callback, trads = null) => {
  if(error.response !== undefined) {
    if(error.response.status === 401) {
      let paramUrl = document.location.href;
      if(paramUrl !== undefined && paramUrl !== null) {
        let splitUrl =  paramUrl.split(config.url.URL);
        if(splitUrl.length > 1) {
          paramUrl = splitUrl[1].split('/') as any;
          document.location.href = `${config.url.URL}${paramUrl[0]}/${paramUrl[1]}/login`;
        } else {
          // document.location.href += `login`;
          // document.location.href = `${config.url.URL}${token}/${lang}/login`;
        }
      }
    } else if (error.response) {
      /*
      * The request was made and the server responded with a
      * status code that falls out of the range of 2xx
      */
      if(error.response !== null && error.response.data !== null && error.response.data.message !== null) {

        if (trads && trads?.[error.response.data.message]) {
          toast.error(trads[error.response.data.message]);
        } else {
          toast.error(ListErrorHtml[error.response.status].description + ", " + error.response.data.message);
        }
      } else {
        toast.error(ListErrorHtml[error.response.status].description + ", " + ListErrorHtml[error.response.status].comment);
      }
    } else {
      toast.error(error.message);
    }
  } else if (error.request !== undefined) {
    /*
    * The request was made but no response was received, `error.request`
    * is an instance of XMLHttpRequest in the browser and an instance
    * of http.ClientRequest in Node.js
    */
    toast.error(error.message);
    //toast.error( stringify(error) );
    //toast.error("01");
  } else {
    toast.error(error.message);
    //toast.error("02");
  }
  callback();
}

export const ListErrorHtml = {
  100 : {code: 100, description: 'Continue', comment: null},
  101 : {code: 101, description: 'Switching Protocols', comment: null},
  200 : {code: 200, description: 'OK', comment: 'Action completed successfully'},
  201 : {code: 201, description: 'Created', comment: 'Success following a POST command'},
  202 : {code: 202, description: 'Accepted', comment: 'Request has been accepted for processing, but processing has not completed'},
  203 : {code: 203, description: 'Partial Information', comment: 'Response to a GET command; indicates that the returned meta information is from a private overlaid web'},
  204 : {code: 204, description: 'No Content', comment: 'Server received the request, but there is no information to send back'},
  205 : {code: 205, description: 'Reset Content', comment: null},
  206 : {code: 206, description: 'Partial Content', comment: 'Requested file was partially sent; usually caused by stopping or refreshing a web page'},
  300 : {code: 300, description: 'Multiple Choices', comment: null},
  301 : {code: 301, description: 'Moved Permanently', comment: 'Requested a directory instead of a specific file; the web server added the file name index.html, index.htm, home.html, or home.htm to the URL'},
  302 : {code: 302, description: 'Moved Temporarily', comment: null},
  303 : {code: 303, description: 'See Other', comment: null},
  304 : {code: 304, description: 'Not Modified', comment: 'Cached version of the requested file is the same as the file to be sent'},
  305 : {code: 305, description: 'Use Proxy', comment: null},
  400 : {code: 400, description: 'Bad Request', comment: 'Request had bad syntax or was impossible to fulfill'},
  401 : {code: 401, description: 'Unauthorized', comment: 'User failed to provide a valid user name/password required for access to a file/directory'},
  402 : {code: 402, description: 'Payment Required', comment: null},
  403 : {code: 403, description: 'Forbidden', comment: 'Request does not specify the file name, or the directory or the file does not have the permission that allows the pages to be viewed from the web'},
  404 : {code: 404, description: 'Not Found', comment: 'Requested file was not found'},
  405 : {code: 405, description: 'Method Not Allowed', comment: null},
  406 : {code: 406, description: 'Not Acceptable', comment: null},
  407 : {code: 407, description: 'Proxy Authentication Required', comment: null},
  408 : {code: 408, description: 'Request Time-Out', comment: null},
  409 : {code: 409, description: 'Conflict', comment: null},
  410 : {code: 410, description: 'Gone', comment: null},
  411 : {code: 411, description: 'Length Required', comment: null},
  412 : {code: 412, description: 'Precondition Failed', comment: null},
  413 : {code: 413, description: 'Request Entity Too Large', comment: null},
  414 : {code: 414, description: 'Request-URL Too Large', comment: null},
  415 : {code: 415, description: 'Unsupported Media Type', comment: null},
  500 : {code: 500, description: 'Server Error', comment: 'In most cases, this error results from a problem with the code or program you are calling rather than with the web server itself.'},
  501 : {code: 501, description: 'Not Implemented', comment: 'Server does not support the facility required'},
  502 : {code: 502, description: 'Bad Gateway', comment: null},
  503 : {code: 503, description: 'Out of Resources', comment: 'Server cannot process the request due to a system overload; should be a temporary condition'},
  504 : {code: 504, description: 'Gateway Time-Out', comment: 'Service did not respond within the time frame that the gateway was willing to wait'},
  505 : {code: 505, description: 'HTTP Version Not Supported', comment: null},
}

export default axios.create({
  baseURL: config.url.API_URL,
  responseType: "json",
  // Required by the server to accept the session cookie.
  headers: { 'X-Requested-With': 'XMLHttpRequest' },
  // Send the session cookie when the API is on another origin (dev server only).
  withCredentials: new URL(config.url.API_URL).origin !== window.location.origin
});